function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_3534",
  "data-name": "Group 3534",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32.18",
  height: "27.583"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3533",
  "data-name": "Group 3533",
  fill: "#4269a1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1010",
  "data-name": "Path 1010",
  d: "M323.448 134.9a3.448 3.448 0 10-3.448-3.452 3.449 3.449 0 003.448 3.452z",
  transform: "translate(-299.313 -123.403)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1011",
  "data-name": "Path 1011",
  d: "M62.169 64H34.011A2.017 2.017 0 0032 66.033V89.55a2.017 2.017 0 002.011 2.033h28.158a2.017 2.017 0 002.011-2.033V66.033A2.017 2.017 0 0062.169 64zm-7.406 14.2a1.233 1.233 0 00-.919-.445 1.419 1.419 0 00-.919.409L51.581 79.3a1.348 1.348 0 01-.826.338 1.188 1.188 0 01-.79-.295 10.85 10.85 0 01-.309-.295l-3.865-4.181a1.584 1.584 0 00-1.2-.539 1.631 1.631 0 00-1.207.56L34.3 85.851V67.139a.947.947 0 01.941-.84h25.693a.912.912 0 01.927.862l.022 18.7z",
  transform: "translate(-32 -64)"
}))));